import { render, staticRenderFns } from "./HeadText.vue?vue&type=template&id=c1d03206&scoped=true&"
import script from "./HeadText.vue?vue&type=script&lang=js&"
export * from "./HeadText.vue?vue&type=script&lang=js&"
import style0 from "./HeadText.vue?vue&type=style&index=0&id=c1d03206&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.10.2_uesoswnqfrvbmgjykhrr3r374i/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1d03206",
  null
  
)

export default component.exports